module.exports = __webpack_public_path__ + "static/media/bg_inquiry.321d108e.png";